var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { name: "fade" } }, [
    _vm.shouldDisplay
      ? _c(
          "div",
          {
            staticClass: "documents-need-add-all-added",
            on: { click: _vm.closeAction },
          },
          [
            _c(
              "svg",
              {
                attrs: {
                  width: "14",
                  height: "10",
                  viewBox: "0 0 14 10",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg",
                },
              },
              [
                _c("path", {
                  attrs: {
                    d: "M4.47288 9.68401C4.08236 9.29348 4.08236 8.66032 4.47288 8.2698L12.2929 0.449632C12.6835 0.0591074 13.3166 0.059107 13.7072 0.449631C14.0977 0.840156 14.0977 1.47332 13.7072 1.86384L5.8871 9.68401C5.49657 10.0745 4.86341 10.0745 4.47288 9.68401Z",
                    fill: "#12C971",
                  },
                }),
                _c("path", {
                  attrs: {
                    d: "M5.8871 9.68401C6.27762 9.29348 6.27756 8.66032 5.88704 8.2698L1.70711 4.08989C1.31658 3.69937 0.683417 3.69937 0.292893 4.08989C-0.097631 4.48042 -0.0976311 5.11358 0.292893 5.50411L4.47288 9.68401C4.86341 10.0745 5.49657 10.0745 5.8871 9.68401Z",
                    fill: "#12C971",
                  },
                }),
              ]
            ),
            _c("div", { staticClass: "documents-need-add-all-added-message" }, [
              _c(
                "div",
                { staticClass: "documents-need-add-all-added-message-text" },
                [_vm._v(_vm._s(_vm.message))]
              ),
              _c(
                "button",
                {
                  staticClass: "documents-need-add-all-added-message-close",
                  on: { click: _vm.closeAction },
                },
                [_vm._v("Закрыть")]
              ),
            ]),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }